import { DrawerV2 } from '@cleartrip/ct-design-components'
import EmiOptionsList from './EmiOptionsList'

interface EmiOptionsProps {
    openEmiPlans: boolean
    setOpenEmiPlans: (open: boolean) => void
    emiOptionsData: any
    processingFeeMsg: string
    isLoading: boolean
    isError: boolean
    handleRetry?: () => void
}

const EmiOptions: React.FC<EmiOptionsProps> = ({
    openEmiPlans,
    setOpenEmiPlans,
    emiOptionsData = [],
    processingFeeMsg = '',
    isLoading = false,
    isError = false,
    handleRetry
}) => {
    const onClose = () => {
        setOpenEmiPlans(false)
    }
    return (
        <DrawerV2
            direction={'right'}
            children={
                <EmiOptionsList emiOptionsData={emiOptionsData} processingFeeMsg={processingFeeMsg} onClose={onClose} isLoading={isLoading} isError={isError} handleRetry={handleRetry} />
            }
            showOverlay={false}
            isOpen={openEmiPlans}
            handleClose={onClose}
            onExitEnd={() => {}}
            atTop={true}
        />
    )
}

export default EmiOptions
